import Vue from "vue";
import App from "./App.vue";
// import './registerServiceWorker'
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./components/digitMixin";
import "@babel/polyfill";
import "./plugins/toastification";
import "./plugins/persianDatePicker";
import "./filters";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
